export default __webpack_public_path__ + "static/media/information--end-of-overtaking-permitted-heavy-good-vehicles--g1.b36d111d.png";